import {
  List,
  ListItem,
  ActionBar,
  ActionBarButtons,
  CreateActionButton,
  Picture,
  concatValues,
  withBrowser,
  browserShape,
  intlShape,
  withAccessRights,
  accessRightsShape,
  withIntl,
} from "lcm-iot-commons";

import {
  gatewayIconClassName,
  statusBubbleFieldGateway,
} from "../../utils/statusUtils";
import { getFieldGatewayImageUrl } from "./PicturePoolUrl";

type Props = {
  fieldGateways: {
    id?: number;
    name?: string;
    description?: string;
    ip_address?: string;
    type?: {
      id?: number;
      code?: string;
      name?: string;
    };
    status?: {
      id?: number;
      code?: string;
      name?: string;
    };
  }[];
  browser: browserShape;
  intl: intlShape;
  accessRights: accessRightsShape;
  edgeDevice: {
    id?: number;
    lastSeenAt?: number;
  };
};

export function FieldGateways({
  intl,
  browser,
  accessRights,
  edgeDevice,
  fieldGateways,
}: Props) {
  return (
    <div>
      <ActionBar>
        <h2 id="field-gateways-header">
          {intl.formatMessage({ id: "field_gateways.header" })}
        </h2>
        <ActionBarButtons>
          <CreateActionButton
            // @ts-expect-error TS(2322) FIXME: Type '{ id: string; disabled: boolean; target: str... Remove this comment to see the full error message
            id="create-field-gateway-button"
            disabled={!accessRights.canUpdate}
            target={`/edge_devices/${edgeDevice.id}/field_gateways/create`}
          />
        </ActionBarButtons>
      </ActionBar>
      <List id="field-gateways-list">
        {fieldGateways.map((fieldGateway) => (
          <ListItem
            id={`field-gateway-list-item-${fieldGateway.id}`}
            key={fieldGateway.id}
            title={concatValues(
              [
                `${fieldGateway.name} ${fieldGateway.ip_address}`,
                // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                fieldGateway.type.name,
              ],
              " - ",
            )}
            value={fieldGateway.description}
            image={
              <Picture
                width={50}
                height={50}
                // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                src={getFieldGatewayImageUrl(fieldGateway.type.code, 50)}
                placeholder={gatewayIconClassName()}
              />
            }
            status={statusBubbleFieldGateway(
              // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
              fieldGateway.status.code,
              // @ts-expect-error TS(2345) FIXME: Argument of type '{ id?: number | undefined; lastS... Remove this comment to see the full error message
              edgeDevice,
            )}
            onClick={() =>
              browser.navigateTo(
                `/edge_devices/${edgeDevice.id}/field_gateways/${fieldGateway.id}`,
              )
            }
            // @ts-expect-error TS(2322) FIXME: Type '{ id: string; key: number | undefined; title... Remove this comment to see the full error message
            showItemMenu
          />
        ))}
      </List>
    </div>
  );
}

export default withIntl(
  withBrowser(withAccessRights(FieldGateways, "EDM::EdgeDevice")),
);
